import React, { useEffect } from 'react';

import backgroundImg from '~/assets/images/auditorium-background-merged.jpg';
import { 
  PageContainer, 
  PageHeadline, 
  PageComingSoon, 
  TopContainer
} from '~/components/layout/PageBasics';
import { breakpoints, css, fluidRange, respondFrom, respondTo, styled } from '~/styles';
import config from '~/config';


const StyledPageContainer = styled(PageContainer)`
  &:before {
    background-position: center 70%;  // products' center
  }

  /* ${respondTo(breakpoints.md, css`
    &:before {
      display: none;
    }
  `)} */
`

const StyledTopContainer = styled(TopContainer)`
  justify-content: flex-start;
  /* &:before {
    background-position: center 56%;  // products' center
  }

  ${respondFrom(breakpoints.md, css` */
    &:before {
      display: none;
    }
  /* `)} */
`

const StyledPageHeadline = styled(PageHeadline)`
${fluidRange('marginTop', '30px', '100px')}
`

function AuditoriumPage() {
  useEffect(() => {
    document.title = config.title + ' | Auditorium';
  }, []);

  return (
    <StyledPageContainer bgImage={backgroundImg}>
      <StyledTopContainer bgImage={backgroundImg}>
        <StyledPageHeadline>
          <span>Revance<b>U</b></span> <span>Peer-to-Peer</span>
        </StyledPageHeadline>
        <PageComingSoon>Coming soon</PageComingSoon>
      </StyledTopContainer>
    </StyledPageContainer>
  );
}

export default AuditoriumPage;



// WEBPACK FOOTER //
// ./src/pages/auditorium/index.tsx